var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "csp-base-file-upload",
    _vm._b(
      {
        attrs: {
          "additional-params": _vm.additionalParams,
          "on-transform": _vm.handleFileTransform,
          "show-message": false,
          title: "",
          "upload-url": _vm.uploadUrl,
          "wrapper-classes": _vm.wrapperClasses,
        },
        on: { "upload-complete": _vm.handleUploadComplete },
      },
      "csp-base-file-upload",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "span",
        _vm._b(
          { staticClass: "upload-icon" },
          "span",
          _vm.iconAttributes,
          false
        ),
        [
          _c("b-img", {
            attrs: {
              alt: "File Upload Image",
              height: "100",
              src: _vm.imageFileUpload,
              width: "100",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "text-uppercase font-weight-bold upload-label" }, [
        _vm._v("\n        " + _vm._s(_vm.uploadLabel) + "\n    "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }